import React from 'react';
import { i18next } from '@yola/ws-sdk';
import contextMenu from 'src/js/modules/context-menu';
import segment from 'src/js/modules/analytics/segment';
import BlockHideOnContainer from '../containers/block-hide-on-container';
import getParentWidgetByElement from '../helpers/get-parent-widget-by-element';
import isElementColumnInCustomBlock from '../helpers/is-element-column-in-custom-block';
import { WIDGET_CONTEXT_MENU_GROUP_NAME } from '../constants/common';
import { WIDGET_HIDE_ON } from '../constants/context-menu-block-items';

const getWidgetHideTarget = (element) => {
  if (isElementColumnInCustomBlock(element)) {
    return element.querySelector('ws-block[widget]');
  }

  return getParentWidgetByElement(element);
};

export const registerWidgetVisibilityContextMenu = () => {
  contextMenu.operations.registerItemsGroup({
    groupName: WIDGET_CONTEXT_MENU_GROUP_NAME,
    prepareElement: getWidgetHideTarget,
    items: [
      {
        id: WIDGET_HIDE_ON,
        matches: (element, featureFlags = {}) =>
          Boolean(featureFlags.breakpoint_editing) && Boolean(getWidgetHideTarget(element)),
        menuNode: (
          <BlockHideOnContainer
            isWidget
            title={i18next.t('Hide widget on')}
            triggerId={segment.constants.triggerIds.ELEMENT_CONTEXT_MENU}
          />
        ),
      },
    ],
  });
};
